import { PAGOS_LOGOS } from '@/lib/brand';
import { cn } from '@/lib/utils';

export function PaymentMarks({ className, compact = false }: { className?: string; compact?: boolean }) {
  const h = compact ? 'h-6' : 'h-8';
  return (
    <div className={cn('flex flex-wrap items-center gap-3', className)} aria-label="Pagos con Visa, Mastercard y Openpay">
      <img src={PAGOS_LOGOS.visa} alt="Visa" className={`${h} w-auto`} />
      <img src={PAGOS_LOGOS.mastercard} alt="Mastercard" className={`${h} w-auto`} />
      <a
        href="https://www.openpay.mx"
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center"
        title="Openpay"
      >
        <img src={PAGOS_LOGOS.openpay} alt="Openpay" className={`${compact ? 'h-7' : 'h-9'} w-auto`} />
      </a>
    </div>
  );
}
